import ListSoldProductsTable from './ListSoldProductsTable';

export default ListSoldProductsTable;
